const PRODUCT_SELECT2_OPTIONS = {
  width: '100%',
  theme: 'bootstrap',
  placeholder: '選択してください',
  allowClear: true,
  language: {
    noResults: function () {
      return '見つかりません。';
    },
  },
};

function reinitObjectLeaseTypeSelect(data) {
  const $el = $('#object_lease_type_standard');
  if ($el.hasClass('select2-hidden-accessible')) {
    $el.select2('destroy');
  }
  $el.empty().select2($.extend({}, PRODUCT_SELECT2_OPTIONS, {
    data: data && data.length ? data : [{ id: '', text: '' }],
  }));
}

$(document).ready(function () {
  const productType = $('#product_type_standard');

  productType.on('change', function () {
    var producttypeId = $(this).val();
    reinitObjectLeaseTypeSelect([{ id: '', text: '' }]);
    if (producttypeId) {
      loadObjectLeaseTypes(producttypeId);
    }
  });

  const init_select2 = (selector) => {
    $(selector).select2(PRODUCT_SELECT2_OPTIONS);
  };

  init_select2('.select2');

  const handleNewlyAddedRow = (row) => {
    const $row = $(row);
    if ($row.hasClass('newly-added-row')) return;

    const field = $row.find('.select2');
    init_select2(field);
    checkIsPriceFirst();

    $row.addClass('newly-added-row');
  };

  const attachNestedFieldsObserver = (container) => {
    if (!container) return;
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1 && node.classList.contains('nested-fields')) {
            handleNewlyAddedRow(node);
          }
        });
      });
    });
    observer.observe(container, { childList: true });
  };

  document.querySelectorAll('.multi-field-wrapper').forEach(attachNestedFieldsObserver);

  $(document).on('cocoon:after-insert', '.multi-field-wrapper', function (_, row) {
    handleNewlyAddedRow(row);
  });

  $('.js-select-maker').on('change', function() {
    $('.js-select-model').find('option').remove();
    $('.js-select-type').find('option').remove();
    let makerId = $(this).val();

    if (!!makerId) {
      $('.js-select-model').prop('disabled', false);

      $.ajax({
        url: `/makers/${makerId}/load_models`,
        method: 'GET',
        success: function (res) {
          $.each(res.models, function (i, item) {
            $('.js-select-model').append($('<option>', {
              value: item.id,
              text : item.name
            }));
            $('.js-select-type').append($('<option>', {
              value: item.object_lease_type_id,
              text : item.object_lease_type_name
            }));
          });
          let maker_id = $(".js-select-maker").find(":selected").text();
          let object_lease_type_id = $('.js-select-type').find("option:first-child").text();
          let model_id = $(".js-select-model").find("option:first-child").text();
          $("#name").val(maker_id+object_lease_type_id+model_id);
        },
      });
    } else {
      $('.js-select-model').prop('disabled', true);
    }
  })

  $('#name').on('change', function() {
    $('#estimate_name').val($(this).val());
  })

  $('#accept_edit_price_second_standard').on('change', function() {
    if($(this).is(":checked")){
      $('.product_price_second').removeClass('readonly');
      $('#price_second_standard').prop('readonly', false);
      $('#price_second_standard').removeClass('readonly');
      $('#price_second_standard').css({ "background": ""})
    } else {
      $('#price_second_standard').prop('readonly', true);
      $('.product_price_second').addClass('readonly');
      $('#price_second_standard').addClass('readonly');
      $('#price_second_standard').css({ "background": "#e9ecef"})
      var priceFirst = $('#price_second_standard').data('price-first');
      if(priceFirst !== undefined){
        $('#price_second_standard').val(priceFirst);
      } else {
        $('#price_second_standard').val($('#price_second_standard').data('value'));
      }
    }
  })

  $('.btn-add-partner').on('click', function(){
    setTimeout(function () {
      $(".input_decimal:last").inputFilterx(function(value) {
        return /^[-ー−]?[0-9０-９]{0,8}(([.．。][0-9０-９]{0,2})?)$/.test(value.replace(/,/g,''));
      }, "整数部分は最大8桁、小数部分は最大2桁です。");
    }, 50);
  })

  checkIsPriceFirst();
  initializePriceFromDefaultSupplier();

  $('.product-form').on('submit', function(e) {
    var hasError = false;

    $('.supplier-error').remove();

    $('.newly-added-row:visible').each(function() {
      var supplierSelect = $(this).find('.partner-product');
      var supplierValue = supplierSelect.val();

      supplierSelect.closest('.col-md-2').find('.form-select').removeClass('is-invalid');

      if (!supplierValue || supplierValue === '') {
        supplierSelect.addClass('is-invalid');

        var errorMsg = '<div class="invalid-feedback supplier-error">このフィールドは必須です。</div>';
        supplierSelect.closest('.col-md-2').append(errorMsg);

        hasError = true;
      }
    });

    if (hasError) {
      e.preventDefault();
      return false;
    }
  });
});

$(document).on('change', '.js-is-price-first, .product_partner_products_price input', function (e) {
  checkIsPriceFirst();
  updatePrice();
});

$(document).on('click', '.popover-custom-area .js-btn-ok', function () {
  var $supplierRow = window.removeFieldDynamicContainter;
  if (!$supplierRow || !$supplierRow.find('.js-is-price-first').length) {
    return;
  }

  setTimeout(function () {
    checkIsPriceFirst();
    updatePrice();
  }, 0);
});

function loadObjectLeaseTypes(producttypeId) {
  $.ajax({
    url: "/products/load_object_lease_types",
    method: "GET",
    data: { product_type_id: producttypeId },
    success: function (res) {
      var object_lease_types = _.map(res.object_lease_types, function (object_lease_type) {
        return { id: object_lease_type.id, text: object_lease_type.name };
      })
      $("#object_lease_type_standard").html('').select2({ data: object_lease_types });
      $("#object_lease_type_standard").select2({
        theme: 'bootstrap',
        placeholder: '選択してください',
        allowClear: true,
        language: {
          noResults: function () {
            return '見つかりません。';
          },
        },
      });
      object_lease_types.unshift({ id: '', text: '' });
      reinitObjectLeaseTypeSelect(object_lease_types);
    },
  });
}

function checkIsPriceFirst() {
  var $activeCheckboxes = activeDefaultSupplierCheckboxes();
  if($activeCheckboxes.filter(':checked').length > 0) {
    $activeCheckboxes.not(':checked').prop('disabled', true);
  } else {
    $activeCheckboxes.not(':checked').prop('disabled', false);
  }
}

function activeDefaultSupplierCheckboxes() {
  return $('.js-is-price-first').filter(function () {
    return $(this).closest('.nested-fields').find('.destroy-mode').val() !== 'true';
  });
}

function defaultSupplierRow() {
  return activeDefaultSupplierCheckboxes().filter(':checked').first().closest('.row');
}

function initializePriceFromDefaultSupplier() {
  var $priceFirst = $('#price_first_standard');
  var $defaultSupplier = defaultSupplierRow();

  if (!$priceFirst.length || $priceFirst.val() || !$defaultSupplier.length) {
    return;
  }

  var price = $defaultSupplier.find('.product_partner_products_price input').val();
  if (!price) {
    return;
  }

  var $priceSecond = $('#price_second_standard');
  $priceFirst.val(price);
  $priceSecond.data('price-first', price);

  if (!$priceSecond.val()) {
    $priceSecond.val(price);
  }
}

function updatePrice(){
  var $defaultSupplier = defaultSupplierRow();
  var price = $defaultSupplier.length ? $defaultSupplier.find('.product_partner_products_price input').val() : '';
  $('#price_first_standard').val(price);
  $('#price_second_standard').data('price-first', price);
  $('#price_second_standard').val(price);
}
